"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrialsApi = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var TRIAL_ENDPOINT_BASE = 'trials/v1/hub-trials';

var _cachedAvailable;

var _cachedTrials;

var TrialsApi = {
  getTrialState: function getTrialState() {
    if (_cachedTrials) {
      return _cachedTrials;
    }

    _cachedTrials = _apiClient.default.get(TRIAL_ENDPOINT_BASE + "?active=false");
    return _cachedTrials;
  },
  getAvailableTrials: function getAvailableTrials() {
    if (_cachedAvailable) {
      return _cachedAvailable;
    }

    _cachedAvailable = _apiClient.default.get(TRIAL_ENDPOINT_BASE + "/available");
    return _cachedAvailable;
  }
};
exports.TrialsApi = TrialsApi;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/core/api/trialApi.js
// module id = 764
// module chunks = 5 6